import React, { FC } from 'react'
import makeStyles from '@mui/styles/makeStyles';
import { convertFromRaw } from 'draft-js'
import { stateToMarkdown } from 'draft-js-export-markdown'

import TextEditor from '../../texteditor/TextEditor'

import { getProps } from '@kaidam/fc-shared/src/frontend/components/form/fields/utils'

import {
  FormFieldProps,
} from '../../../types/form'

const useStyles = makeStyles(theme => ({
  root: {
    height: '300px',
  },
}))

const Markdown: FC<React.PropsWithChildren<FormFieldProps>> = (props) => {

  const classes = useStyles()
  const {
    field: {
      name,
      value,
    },
    form: {
      setFieldValue,
    },
    readonly,
  } = getProps(props)

  const onChange = (raw: any) => {
    if(!raw) return
    const markdown = stateToMarkdown(convertFromRaw(raw))
    setFieldValue(name, {
      raw,
      markdown,
    })
  }
  
  return (
    <div className={ classes.root }>
      <TextEditor
        value={ value ? value.raw : null }
        onChange={ onChange }
      />
    </div>
  )
}

export default Markdown